const sortByPosition = (arr) => {
  return arr.sort((a, b) => {
    const positionA = parseInt(a.position.split(' ')[0]);
    const positionB = parseInt(b.position.split(' ')[0]);
    return positionA - positionB;
  });
};
const pageViewPromoDetail = (params) => {
  if (params && params.length > 0) {
    if (typeof window !== 'undefined') {
      (window as any)?.dataLayer?.push({
        event: 'promotionView',
        eventCategory: 'ecommerce promotion',
        eventLabel: `promo lainnya`,
        ecommerce: {
          promoView: {
            promotions: sortByPosition(params),
          },
        },
      });
    }
  }
};
export default pageViewPromoDetail;
